import React from 'react'
import type { CountUpProps } from 'react-countup'
import ReactCountUpLib from 'react-countup'

const ReactCountUp: React.FC<CountUpProps> =
  typeof ReactCountUpLib === 'function'
    ? (ReactCountUpLib as React.FC<CountUpProps>)
    : (ReactCountUpLib as { default: React.FC<CountUpProps> }).default

export default ReactCountUp
